export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "custom.worker.d5f8dcd1d51ddead4815-custom.worker.worker.js");
}
